module.exports = __webpack_public_path__ + "static/p4-a3295cf1016b2f10d69a3a4db4ee8bed.svg";